import { PropsWithClassName } from '@Framework/ui';
import React, { PropsWithChildren } from 'react';

import { DESKTOP, MOBILE } from '../ShopLogo/ShopLogo';
import logo from './assets/logo-zava.svg';

interface Props extends PropsWithClassName {
  mobile: boolean;
  alt: string;
}

const LogoZava: React.FC<Props> = (props: PropsWithChildren<Props>): React.ReactElement => {
  const { mobile, alt, ...imgAttrs } = props;

  const size = {
    [MOBILE]: { width: 110, height: 43 },
    [DESKTOP]: { width: 180 - 180 * 0.4, height: 100 - 100 * 0.4 }
  };
  const currentSize = size[mobile ? MOBILE : DESKTOP];

  return (
    <img
      className={props.className}
      width={currentSize.width}
      height={currentSize.height}
      data-testid={'logo-zava-root'}
      alt={alt}
      src={logo}
      {...imgAttrs}
    />
  );
};

export { LogoZava };
